<template>
  <div v-if="info && activePage === 'basic-information'" class="inner-graph-content">
    <Spinner :isLoading="isLoading" />
    <div class="basic-information">
      <div class="basic-content-area pt-0">
        <div id="seizure_info" class="detail-content-area">
          <h3>{{ $t('basic_information_seizure_information') }}</h3>
          <div class="basic-info pb-3">
            <p class="title">{{ $t('primary_disease') }}</p>
            <p class="detail" v-for="(item, index) in basicDisease" :key="index">{{ item.answer_value }}</p>
          </div>
          <div class="basic-info pb-3">
            <p class="title">{{ $t('disease_name') }}</p>
            <p class="detail" v-for="(item, index) in diseaseName" :key="index">{{ item.answer_value }}</p>
          </div>
          <!-- copy from common component -->
          <div class="p-detail-info">
            <div class="p-detail-txt-pos clearfix">
              <div class="p-detail-sub01">
                <p>{{ $t('seizure_type_please_tell_the_patient_to_set_the_type_of_seizure_diagnosed') }}</p>
              </div>
              <div class="p-detail-sub02 clearfix">
                <div class="onetime-faq-btn">?</div>
                <p class="onetime-faq-txt"><a href="javascript:;" @click="onSeizureTypeSetting()" class="modal-syncer">{{ $t('seizure_type_setting_method') }}</a></p>
              </div>
            </div>
            <ul class="mb10 clearfix">
              <div class="p-detail-table-pos">
                <table>
                  <tr>
                    <th></th>
                    <th v-for="(item, index) in basic_info.seizures_shortcat" :key="index">{{ $t('seizure_type') }}{{shortcatLabel[index]}}</th>
                  </tr>
                  <tr>
                    <td>{{ $t('optional') }}</td>
                    <td v-for="(item, index) in basic_info.seizures_shortcat" :key="index">
                      {{ basic_info.seizures_shortcat[index] && basic_info.seizures_shortcat[index].shortcat_name ? basic_info.seizures_shortcat[index].shortcat_name : "－" }}
                    </td>
                  </tr>
                  <tr>
                    <td class="p-hilight01">{{ $t('seizure_classification') }}</td>
                    <td :class="basic_info.seizures_shortcat[index] && basic_info.seizures_shortcat[index].seizure_middle_classification_name ? 
                      'p-hilight01' : basic_info.seizures_shortcat[index] && basic_info.seizures_shortcat[index].shortcat_name ? 'p-hilight02' : 'p-hilight01' "
                      v-for="(item, index) in basic_info.seizures_shortcat" :key="index">
                      {{ basic_info.seizures_shortcat[index] && basic_info.seizures_shortcat[index].seizure_middle_classification_name ? 
                      basic_info.seizures_shortcat[index].seizure_middle_classification_name : 
                      basic_info.seizures_shortcat[index] && basic_info.seizures_shortcat[index].shortcat_name ? $t('i_do_not_understand') : "－" }}
                    </td>
                  </tr>
                </table>
              </div>
              <li>
                <p class="info-ttl">{{ $t('number_of_seizures_average_per_day_last_week') }}</p>
                <p>{{ basic_info.average_seizure }}</p>
              </li>
            </ul>
          </div>
           <!-- copy from common component -->
          <div class="doctor-note">
            <p>{{ $t('doctor_note_500_characters') }}</p>
            <textarea
              :placeholder="$t('note_electronic_health_record_url_etc')"
              v-model="basic_info.note"
              maxlength="500"
              data-private
            >
            </textarea>
            <div class="w-100 d-flex justify-content-center m-2">
              <p class="patient-submit-btn" @click="registerNote()">{{ $t('btn_update') }}</p>
            </div>
          </div>

        </div>
        <div id="allergy" class="detail-content-area">
          <h3 class="float-left">{{ $t('allergy') }}</h3>
          <div v-if="$store.state.auth.doctorInfo.home_care_flag === 1 && isLoadingDataAllergy" class="export-allergy-btn" @click="onClickExportAllegyPDF">
            {{ $t('pdf_export') }}
          </div>
          <div v-if="!isLoadingDataAllergy" style="text-align: center;">
            <img style="height:100px margin: 25px 0" src="/common/img/loading.gif"/>
          </div>
          <div v-else class="basic-info-table">
            <table>
              <tbody>
                <tr>
                  <td class="title-v">{{ $t('pollen') }}</td>
                  <td >{{ listAllergy('allergies_pollen') ? listAllergy('allergies_pollen') : '－' }}</td>
                </tr>
                <tr>
                  <td class="title-v">{{ $t('food') }}</td>
                  <td>{{ listAllergy('allergies_food') ? listAllergy('allergies_food') : '－' }}</td>
                </tr>
                <tr>
                  <td class="title-v">{{ $t('metal') }}</td>
                  <td>{{ listAllergy('allergies_metal') ? listAllergy('allergies_metal') : '－' }}</td>
                </tr>
                <tr>
                  <td class="title-v">{{ $t('animal') }}</td>
                  <td>{{ listAllergy('allergies_animal') ? listAllergy('allergies_animal') : '－' }}</td>
                </tr>
                <tr>
                  <td class="title-v">{{ $t('others') }}</td>
                  <td>{{ listAllergy('allergies_other') ? listAllergy('allergies_other') : '－' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div id="medical_history" class="detail-content-area">
          <h3>{{ $t('medical_history') }}</h3>
          <div v-if="!isLoadingDataMedicalHistories" style="text-align: center;">
            <img style="height:100px margin: 25px 0" src="/common/img/loading.gif"/>
          </div>
          <template v-else>
            <p>{{ $t('medical_history_status') }}</p>
            <ul>
              <li>
                <label>
                  <input type="checkbox" class="checkbox-input" :checked="isCheckedHospitalVisit" v-model="isCheckedHospitalVisit"/>
                  <span class="checkbox-parts">{{ $t('outpatient_treatment') }}</span>
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" class="checkbox-input" :checked="isCheckedOperation" v-model="isCheckedOperation"/>
                  <span class="checkbox-parts">{{ $t('recovery') }}</span>
                </label>
              </li>
              <li>
                <label>
                  <input type="checkbox" class="checkbox-input" :checked="isCheckedCompleteCure" v-model="isCheckedCompleteCure"/>
                  <span class="checkbox-parts">{{ $t('operation') }}</span>
                </label>
              </li>
            </ul>
            <p class="pb-1">{{ $t('last_seizure_date_and_time') }}</p>
            <p class="pb-4">{{ eventSeizureNewest }}</p>
            <div class="basic-info-table">
              <table>
                <thead>
                  <tr>
                    <th class="w-200">{{ $t('onset_seizure_operation_date') }}</th>
                    <th>{{ $t('disease_name_operation') }}</th>
                    <th class="w-200">{{ $t('medical_history_status') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in medical_history" :key="index">
                    <td>{{ item.date ? convertToJPTime(item.date) : 'ー' }}</td>
                    <td>{{ item.name }}</td>
                    <td class="text-center">{{ item.status ? getMedicalStatus(item.status) : 'ー' }}</td>
                  </tr>
                  <tr v-if="medical_history.length == 0">
                    <td colspan="3" style="text-align: center; font-size: 12px;">{{ $t('there_is_no_data') }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </div>
        <div id="visitted_hospital" class="detail-content-area">
          <h3>{{ $t('hospital_visiting_history') }}</h3>
          <div v-if="!isLoadingDataVisitedHospital" style="text-align: center;">
            <img style="height:100px margin: 25px 0" src="/common/img/loading.gif"/>
          </div>
          <div v-else class="basic-info-table">
            <table>
              <thead>
                <tr>
                  <th class="w-200">{{ $t('start_date') }}</th>
                  <th class="w-200">{{ $t('end_date') }}</th>
                  <th>{{ $t('medical_institution') }}</th>
                  <th class="w-200">{{ $t('doctor_in_charge') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in visitedHospital" :key="index">
                  <td>{{ item.hospitalization_date ? convertToJPTime(item.hospitalization_date) : '－' }}</td>
                  <td>{{ item.hospital_discharge_date ? convertToJPTime(item.hospital_discharge_date) : '－' }}</td>
                  <td>{{ item.medical_institution_name ? item.medical_institution_name : '－' }}</td>
                  <td>{{ item.doctor_in_charge_name ? item.doctor_in_charge_name : '－' }}</td>
                </tr>
                <tr v-if="visitedHospital.length == 0">
                  <td colspan="4" style="text-align: center; font-size: 12px;">{{ $t('there_is_no_data') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- copy from common component -->
    <b-modal id="modal-seizure-type" class="modal-content" content-class="patient-detail-seizure-type" centered :hide-header="true" :hide-footer="true">
      <div class="modal-inner">
        <p class="modal-ttl">{{ $t('seizure_type_setting_method') }}</p>
        <div class="modal-content-setting mb40 clearfix">
          <div class="setting-inner-pos01">
            <p class="setting-txt">{{ $t('input_of_seizure_type') }}</p>
            <p class="setting-ex-txt" v-html="$t('added_shortcut_name_for_seizure_type')"></p>
            <p class="mb10"><img width="315" :src="$t('image.patient')" alt=""></p>
            <div class="setting-txt-area01">
              <p v-html="$t('the_seizure_type_shortcut_name_is_the_name_displayed_in_the_one_tap_seizure_record_or_seizure_graph')"></p>
            </div>
          </div>
          <div class="setting-inner-pos02">
            <p class="setting-txt">{{ $t('to_select_seizure_classification') }}</p>
            <p class="setting-ex-txt" v-html="$t('seizures_classification_was_diagnosed_by_your_doctor')"></p>
            <div class="m-setting-table mb10">
              <table>
                <tr>
                  <th width="130">{{ $t('seizure_classification_vi') }}</th>
                  <th width="155">{{ $t('symptom_example') }}</th>
                </tr>
                <tr>
                  <td>{{ $t('focus_partial_seizures_conscious') }}</td>
                  <td>{{ $t('the_left_arm_stretches_the_face_turns_to_the_left_etc') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('focus_partial_seizures_unconscious') }}</td>
                  <td>{{ $t('focused_seizures_that_are_unresponsive_unconscious_when_called') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('focus_origin_tonic_clonic_seizures') }}</td>
                  <td>{{ $t('seizures_that_transition_from_focused_seizures_to_tonic_clonic_seizures') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('tonic_seizures') }}</td>
                  <td>{{ $t('seizures_that_make_the_whole_body_stick_like_a_stick_for_a_while_a_few_seconds_to_10_seconds') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('clonus_seizures') }}</td>
                  <td>{{ $t('seizures_that_make_the_whole_body_scratchy') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('tonic_clonic_seizures') }}</td>
                  <td>{{ $t('seizures_that_cause_the_whole_body_to_stretch_and_then_tingle') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('myoclonic_seizures') }}</td>
                  <td>{{ $t('seizures_that_make_the_whole_body_or_part_of_the_body_snap_for_a_moment') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('myoclonic_atonic_seizure') }}</td>
                  <td>{{ $t('seizures_that_weaken_the_whole_body_following_myoclonic_seizures') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('atonic_seizure') }}</td>
                  <td>{{ $t('a_seizure_in_which_the_whole_body_suddenly_loses_power') }}　</td>
                </tr>
                <tr>
                  <td>{{ $t('absence_seizures') }}</td>
                  <td>{{ $t('seizures_that_do_not_respond_to_the_call') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('epileptic_spasm_series') }}</td>
                  <td>{{ $t('when_repeating_epileptic_spasm_repeat_like_hiccups_at_intervals_of_about_5_20_seconds') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('epileptic_spasm_single') }}</td>
                  <td>{{ $t('a_momentary_about_1_second_seizure_such_as_stretching_the_limbs') }}</td>
                </tr>
              </table>
            </div>
            <p class="setting-ex-txt">{{ $t('seizure_classification_supervision_osaka_city_general_medical_center') }}</p>
            <div class="setting-txt-area02">
              <p>{{ $t('determining_seizure_classification_is_not_a_diagnosis') }}</p>
            </div>
          </div>
        </div>
        <div class="btn-base pos-center"><a href="javascript:;" @click="onCancel()" class="modal-close"><p>{{ $t('ok') }}</p></a></div>
      </div>
    </b-modal>
     <!-- copy from common component -->

    <b-modal id="modal-note" centered :hide-header="true" :hide-footer="true">
      <div class="modal-inner">
        <div class="modal-panel-group clearfix">
          <div class="modal-inner">
            <form action="" method="">
              <div class="modal-ttl">
                <p style="font-size: 20px">{{ messageNote }}</p>
              </div>
              <div class="modal-btn-area clearfix">
                <div class="btn-base pos-center"><a href="javascript:;" @click="$bvModal.hide('modal-note')" class="modal-close"><p>{{ $t('ok') }}</p></a></div>
              </div>
            </form>
        </div>
        </div>
      </div>
    </b-modal>

  </div>
</template>
<script>
import { mapState } from "vuex"
import Spinner from "@/js/components/Spinner"
import { convertToJPTime, params, getInfoAndBasicInfo } from '@/js/commons/commons'

export default {
  props: {
    activeTab: {
      type: String,
      required: true
    },
    activePage: {
      type: String,
      required: true
    },
    isLoadedBasicInfo: {
      type: Boolean,
      required: true
    },
    isExportAllergyPDF: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      isLoading: false,
      shortcatLabel: ['A', 'B', 'C', 'D', 'E', 'F'],
      medical_status: [
        {
          id: 1,
          name: this.$t('outpatient_treatment')
        },
        {
          id: 2,
          name: this.$t('operation')
        },
        {
          id: 3,
          name: this.$t('recovery')
        }
      ],
      medical_history: [],
      visitedHospital: [],
      isCheckedHospitalVisit: true,
      isCheckedOperation: true,
      isCheckedCompleteCure: true,
      messageNote: '',
      isLoadingDataAllergy: false,
      isLoadingDataMedicalHistories: false,
      isLoadingDataVisitedHospital: false,
      isDataLoaded: false,
      isSubmitNote: false,
      hostpitalNameNeedToCheck: '大阪母子医療センター'
    }
  },
  components: {
    Spinner
  },
  computed: {
    ...mapState({
      viewedHistories: state => state.patient.viewedHistories,
      info: state => state.patient.info,
      errorMsg: state => state.patient.errorMsg,
      base: state => state.homeCareBook.base,
      allergy: state => state.homeCareBook.allergy,
      medical_histories: state => state.homeCareBook.medical_histories,
      visited_hospital: state => state.homeCareBook.visited_hospital,
      dr_register_note: state => state.patient.dr_children_note,
      basic_info: state => state.patient.basic_info,
    }),
    basicDisease() {
      return this.getDiseaseName('basic_disease')
    },
    diseaseName() {
      return this.getDiseaseName('disease_name')
    },
    eventSeizureNewest() {
      let data = ''
      if(!this.basic_info.event_seizure_newest) {
        return 'ー'
      }
      else if (this.basic_info.event_seizure_newest.event_date && this.basic_info.event_seizure_newest.event_start_time) {
        const [year, month, date] = this.basic_info.event_seizure_newest.event_date.split('-')
        const [hour, minute, second] = this.basic_info.event_seizure_newest.event_start_time.split(':')
        data = this.$t('year_month_day_hour_minute_second', {year: year, month: month, date: date, hour: hour, minute: minute, second: second})
      }
      return data
    }
  },
  methods: {
    onClickExportAllegyPDF() {
      this.$bvModal.show('modal-pdf')
    },
    getVisitedHospital() {
      const data = []
      if (this.visited_hospital.length > 0) {
        const groupById = _(this.visited_hospital).groupBy('children_questionnaire_group_item_answer_id').map(function(items) { return items }).value()
        groupById.map(function(items) { 
          let medical_institution_name = ''
          let doctor_in_charge_name = ''
          let hospitalization_date = ''
          let hospital_discharge_date = ''
          items.map(function(value) {
            switch (value.item_name) {
              case 'medical_institution_name':
                medical_institution_name =  JSON.parse(value.answer).length > 0 ? JSON.parse(value.answer)[0].answer_value : ''
                break
              case 'doctor_in_charge_name':
                doctor_in_charge_name =  JSON.parse(value.answer).length > 0 ? JSON.parse(value.answer)[0].answer_value : ''
                break
              case 'hospitalization_date':
                hospitalization_date =  JSON.parse(value.answer).length > 0 ? JSON.parse(value.answer)[0].answer_value : ''
                break
              case 'hospital_discharge_date':
                hospital_discharge_date =  JSON.parse(value.answer).length > 0 ? JSON.parse(value.answer)[0].answer_value : ''
                break
            }
          })
          data.push({ medical_institution_name, doctor_in_charge_name, hospitalization_date, hospital_discharge_date })
        })
      }
      return data
    },
    onSeizureTypeSetting() {
       this.$bvModal.show('modal-seizure-type')
    },
    onCancel() {
      this.$bvModal.hide('modal-seizure-type')
    },
    getDiseaseName(itemName) {
      const listDiseaseName = []
      this.base.map(function(value) { 
        if (value.item_name === itemName) { JSON.parse(value.answer).map(function(item) { listDiseaseName.push( item ) }) }
      })
      return listDiseaseName
    },
    listAllergy(allergy) {
      const listAllergy = []
      this.allergy.map(function(value) { 
        if (value.item_name === allergy) { JSON.parse(value.answer).map(function(item) { listAllergy.push( item.answer_value ) }) }
      })
      return listAllergy.toString().split(",").join("、")
    },
    getMedicalStatus(id) {
      return this.medical_status.find((item) => item.id === id).name
    },
    medicalHistories() {
      const data = []
      if (this.medical_histories.length > 0) {
        const groupById = _(this.medical_histories).groupBy('children_questionnaire_group_item_answer_id').map(function(items) { return items }).value()
        groupById.map(function(items) { 
          let name = ''
          let date = ''
          let status = ''
          items.map(function(value) {
            switch (value.item_name) {
              case 'disease_name_surgical_detail':
                name = JSON.parse(value.answer).length > 0 ? JSON.parse(value.answer)[0].answer_value : ''
                break
              case 'disease_start_date':
                date = JSON.parse(value.answer).length > 0 ? JSON.parse(value.answer)[0].answer_value : ''
                break
              case 'status':
                status = JSON.parse(value.answer).length > 0 ? JSON.parse(value.answer)[0].answer_value : ''
                break
            }
          })
          data.push({ date, name, status })
        })
      }
      return _.orderBy(data, ['date'], ['desc'])
    },
    convertToJPTime(time) {
      return convertToJPTime(time)
    },
    async registerNote() {
      this.isLoading = true
      if(this.$store.state.auth.typeOfUser !== 'pharmacy') {
        await this.$store.dispatch("patient/registerDrChildrenNote", {
          childId: this.info.id,
          note: this.basic_info.note
        })
      }
      else {
        await this.$store.dispatch("patient/registerDrChildrenNote", {
          childId: this.info.id,
          note: this.basic_info.note,
          pharmacy_user_id: this.$store.state.auth.doctorInfo.id
        })
      }
      if(this.dr_register_note.data) {
        this.messageNote = this.$t('updated_note_successfully')
        this.$bvModal.show('modal-note')
      } else {
        this.messageNote = this.$t('note_update_failed')
        this.$bvModal.show('modal-note')
      }
      this.isLoading = false

    },
    filterDataTrue(id1, dataType1, id2, dataType2, id3) {
      const list = []
      this.medicalHistories().map((item) => {
        if (item.status === id1) {
          list.push({ date: item.date, name: item.name, status: item.status })
        }
        if (dataType1 && item.status === id2) {
          list.push({ date: item.date, name: item.name, status: item.status })
        }
        if (dataType2 && item.status === id3) {
          list.push({ date: item.date, name: item.name, status: item.status })
        }
      })
      return _.orderBy(list, ['date'], ['desc'])
    },
    filterDataFalse(id1, dataType1, id2, dataType2, id3) {
      const list = []
      this.medicalHistories().map((item) => {
        if (item.status != id1) {
          if (dataType1 && item.status === id2) {
            list.push({ date: item.date, name: item.name, status: item.status })
          }
          if (dataType2 && item.status === id3) {
            list.push({ date: item.date, name: item.name, status: item.status })
          }
        }
      })
      return _.orderBy(list, ['date'], ['desc'])
    }
  },
  watch: {
    isCheckedHospitalVisit() {
      if(this.isCheckedHospitalVisit) {
        this.medical_history = this.filterDataTrue(1, this.isCheckedCompleteCure, 2, this.isCheckedOperation, 3)
      } else {
        this.medical_history = this.filterDataFalse(1, this.isCheckedCompleteCure, 2, this.isCheckedOperation, 3)
      }
    },
    isCheckedCompleteCure() {
      if(this.isCheckedCompleteCure) {
        this.medical_history = this.filterDataTrue(2, this.isCheckedHospitalVisit, 1, this.isCheckedOperation, 3)
      } else {
        this.medical_history = this.filterDataFalse(2, this.isCheckedHospitalVisit, 1, this.isCheckedOperation, 3)
      }
    },
    isCheckedOperation() {
      if(this.isCheckedOperation) {
        this.medical_history = this.filterDataTrue(3, this.isCheckedHospitalVisit, 1, this.isCheckedCompleteCure, 2)
      } else {
        this.medical_history = this.filterDataFalse(3, this.isCheckedHospitalVisit, 1, this.isCheckedCompleteCure, 2)
      }
    },
    async activePage() {
      if (this.activePage === 'basic-information' && !this.isDataLoaded) {
        if(!this.isLoadedBasicInfo) {
          this.isLoading = true
          await getInfoAndBasicInfo(this.info.id)
          this.isLoading = false
          this.$emit('setLoadedBasicInfo', true)
        }
        await this.$store.dispatch("homeCareBook/getBasicInfo", { params: params('basic_info', 'allergy', 'get_latest', this.info.id) })
        .then( res => { this.isLoadingDataAllergy = true })
        .catch((error) => {console.log(error)})
        await this.$store.dispatch("homeCareBook/getBasicInfo", { params: params('basic_info', 'medical_history', 'get_latest', this.info.id) })
        .then( res => { this.isLoadingDataMedicalHistories = true })
        .catch((error) => {console.log(error)})
        this.medical_history =  this.medicalHistories()
        await this.$store.dispatch("homeCareBook/getBasicInfo", { params: params('basic_info', 'visited_hospital', 'get_latest', this.info.id) })
        .then( res => { this.isLoadingDataVisitedHospital = true})
        .catch((error) => {console.log(error)})
        this.visitedHospital = this.getVisitedHospital()
        this.isDataLoaded = true
      }
    },
    isExportAllergyPDF() {
      if(this.isExportAllergyPDF) {
        this.$bvModal.hide('modal-pdf')
        this.$emit('setExportAllergyPDF', false)
        let allergyData = (
          (this.listAllergy('allergies_pollen') || '') + '、' +
          (this.listAllergy('allergies_food') || '') + '、' +
          (this.listAllergy('allergies_metal') || '') + '、' +
          (this.listAllergy('allergies_animal') || '')
        ).split('、').filter((i) => i.trim())
        
        this.$store.dispatch('homeCareBook/setAllergyPDF', {
          allergyOther: this.listAllergy('allergies_other') || '',
          allergyData: allergyData,
          child_name: this.$store.state.auth.typeOfUser !== 'pharmacy' ? this.info.name : this.viewedHistories.find((o) => { return o["child_id"] === this.$route.params.childId }).name
        })
        let routeData = this.$router.resolve({name: 'AllergyPDF'})
        window.open(routeData.href, '_blank')
      }
    }
  },
}
</script>

<style lang="css">
  .p-detail-info::-webkit-scrollbar-track {
    background:white;
  }
  .export-allergy-btn {
    padding: 0 20px;
    background-color: #FF8EA1;
    color: white;
    line-height: 30px;
    border-radius: 15px;
    text-align: center;
    float: right;
    position: relative;
    top: -10px;
  }
  .export-allergy-btn:hover {
    cursor: pointer;
  }
</style>
